import { CategoryColumn, Category } from "./CategoryColumn";
import { Patient } from "./PatientCard";
import { useHorizontalScroll } from "@/hooks/useHorizontalScroll";

interface RoomDrawerProps {
  roomName: string;
  patientCount: number;
  avgTAT: string;
  patients: Patient[];
}

export const RoomDrawer = ({
  roomName,
  patientCount,
  avgTAT,
  patients
}: RoomDrawerProps) => {
  const scrollRef = useHorizontalScroll();
  
  const categories: Category[] = [
    { 
      name: "Awaiting Discharge Initiation", 
      count: patients.filter(p => p.categories?.includes("Awaiting Discharge Initiation")).length 
    },
    { 
      name: "Discharge Summary Saved", 
      count: patients.filter(p => p.categories?.includes("Discharge Summary Saved")).length 
    },
    { 
      name: "Discharge Summary Finalized", 
      count: patients.filter(p => p.categories?.includes("Discharge Summary Finalized")).length 
    },
    { 
      name: "Charge Sheet", 
      count: patients.filter(p => p.categories?.includes("Charge Sheet")).length 
    },
    { 
      name: "Pharmacy Clearance", 
      count: patients.filter(p => p.categories?.includes("Pharmacy Clearance")).length 
    },
    { 
      name: "Billing", 
      count: patients.filter(p => p.categories?.includes("Billing & Chargesheet")).length 
    },
    { 
      name: "Payment Processing", 
      count: patients.filter(p => p.categories?.includes("Payment Processing")).length 
    },
    { 
      name: "Physical Discharge", 
      count: patients.filter(p => p.categories?.includes("Physical Discharge")).length 
    }
  ];

  return (
    <div className="bg-muted/30 animate-accordion-down overflow-hidden">
      <div className="p-3">
        {/* Horizontal Scrollable Columns - Drag to Scroll */}
        <div 
          ref={scrollRef}
          className="w-full overflow-x-auto select-none [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
        >
          <div className="flex flex-nowrap space-x-3 pb-2">
            {categories.map((category) => (
              <CategoryColumn
                key={category.name}
                category={category}
                patients={patients.filter(p => 
                  p.categories?.includes(category.name === "Billing" ? "Billing & Chargesheet" : category.name)
                )}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
